import { keyframes } from 'styled-components'

const protrudeLeft = keyframes`
  10%, 90% {
    transform: translateX(-1px);
  }

  20%, 80% {
    transform: translateX(-3px);
  }

  30%, 70% {
    transform: translateX(-5px);
  }

  40%, 50%, 60% {
    transform: translateX(-6px);
  }
`
export default protrudeLeft
